import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { ReportClass } from '../Classes/ReportClass';

@Injectable()
export class ReportService {
  constructor(private http: Http) { }

  GetAllReports() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/Report/GetAllReports', options)
      .map((res: Response) => res.json());
  }

  RunReport(Reportclass: ReportClass) {
    let body = JSON.stringify(Reportclass);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Report/ReportGenerated', body, options)
      .map((res: Response) => res.json());
  }
  GetReportBaseUrl() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/Report/GetReportBaseUrl', options)
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/ReportService.ts